import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UrlSignature } from '../common/apiEndpoint';
import { Portfolio } from './portfolio';

@Injectable()
export class PortfolioService {
  constructor(
    private httpClient: HttpClient,
    private urlSignature: UrlSignature,
  ) {}

  getPortfolioList(personId: string): Observable<Portfolio[]> {
    const url = this.urlSignature.portfolioListUrl + '/' + personId;
    return this.httpClient
      .get(url)
      .pipe(map((response) => response as Portfolio[]));
  }
}
